import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Waiting from '@/components/order/Waiting'
import HotelList from '@/components/hotelsearch/HotelList'
import HotelDetail from '@/components/hotelsearch/HotelDetail'
import WriteOrder from '@/components/order/WriteOrder'
import WritePay from '@/components/order/WritePay'
import MyTrip from '@/components/account/myTrip'
import tripDetail from '@/components/account/tripDetail'
import myAccount from '@/components/account/myAccount'
import myCollection from '@/components/account/myCollection'
import PayResult from '@/components/order/PayResult'
import PayCallbackResult from '@/components/order/PayCallbackResult'
import frequently from '@/components/question/frequently'
import aboutUs from '@/components/question/aboutUs'
import contactUs from '@/components/question/contactUs'
import login from '@/components/login/login'
import oneTouch from '@/components/login/oneTouch'
import forgetPass from '@/components/login/forgetPass'
import resetPassword from '@/components/login/resetPassword'
import register from '@/components/login/register'
import HotelSearch from '@/components/hotelsearch/HotelSearch'
import HotelSearchCond from '@/components/hotelsearch/HotelSearchCond'
import verifyUser from '@/components/account/verifyUser'
import PayDisabled from '@/components/order/PayDisabled'
import myCoupon from '@/components/account/myCoupon'
import Intercepting from '@/components/Intercepting'
import paymentSecondConfirm from '@/components/order/PaymentSecondConfirm'
import accountList from '@/components/account/accountList'
import dashboard from '@/components/dashboard/dashboard'
import termsAndConditions from '@/components/question/termsAndConditions'

Vue.use(Router)

// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: login,
      meta: {
        title: '登录',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/',
      name: 'Home',
      component: Home,
      meta: {
        title: '首页',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/booking/order/Waiting',
      name: 'Waiting',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: Waiting,
      meta: {
        title: '预订等待',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/booking/hotelsearch/HotelList',
      name: 'HotelList',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: HotelList,
      meta: {
        title: '酒店列表',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/booking/hotelsearch/HotelSearch',
      name: 'HotelSearch',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: HotelSearch,
      meta: {
        title: '酒店搜索',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/booking/hotelsearch/HotelSearchCond',
      name: 'HotelSearchCond',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: HotelSearchCond,
      meta: {
        title: '搜索条件',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/booking/hotelsearch/HotelDetail',
      name: 'HotelDetail',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: HotelDetail,
      meta: {
        title: '酒店详情',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/booking/order/WriteOrder',
      name: 'WriteOrder',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: WriteOrder,
      meta: {
        title: '填单及支付合并页',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/booking/order/WritePay',
      name: 'WritePay',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: WritePay,
      meta: {
        title: '订单待支付页面',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/account/MyTrip',
      name: 'MyTrip',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: MyTrip,
      meta: {
        title: '我的行程',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/account/tripDetail',
      name: 'tripDetail',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: tripDetail,
      meta: {
        title: '行程详情',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/account/myAccount',
      name: 'myAccount',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: myAccount,
      meta: {
        title: '我的账户',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/account/myCollection',
      name: 'myCollection',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: myCollection,
      meta: {
        title: '我的收藏',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/booking/order/PayResult',
      name: 'PayResult',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: PayResult,
      meta: {
        title: '订单结果页',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/booking/order/PayCallbackResult',
      name: 'PayCallbackResult',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: PayCallbackResult,
      meta: {
        title: '订单结果页', // 回掉结果页面
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/question/frequently',
      name: 'frequently',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: frequently,
      meta: {
        title: '常见问题',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/question/aboutUs',
      name: 'aboutUs',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: aboutUs,
      meta: {
        title: '关于我们',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/question/contactUs',
      name: 'contactUs',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: contactUs,
      meta: {
        title: '联系我们',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/login',
      name: 'login',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: login,
      meta: {
        title: '登录',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/login/oneTouch',
      name: 'oneTouch',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: oneTouch,
      meta: {
        title: '一键登录',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/login/forgetPass',
      name: 'forgetPass',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: forgetPass,
      meta: {
        title: '忘记密码',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/login/resetPassword',
      name: 'resetPassword',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: resetPassword,
      meta: {
        title: '重置密码',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/account/verifyUser',
      name: 'verifyUser',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: verifyUser,
      meta: {
        title: '邮箱验证',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/order/PayDisabled',
      name: 'PayDisabled',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: PayDisabled,
      meta: {
        title: '支付失效页',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/account/myCoupon',
      name: 'myCoupon',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: myCoupon,
      meta: {
        title: '优惠券',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/intercepting',
      name: 'intercepting',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: Intercepting,
      meta: {
        title: '拦截页面',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/order/paymentSecondConfirm',
      name: 'paymentSecondConfirm',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: paymentSecondConfirm,
      meta: {
        title: '支付成功二次确认页面',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/account/accountList',
      name: 'accountList',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: accountList,
      meta: {
        title: '帐号列表',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/dashboard',
      name: 'dashboard',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: dashboard,
      meta: {
        title: '数据看板',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/question/termsAndConditions',
      name: 'termsAndConditions',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: termsAndConditions,
      meta: {
        title: 'TermsAndConditions',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/portal/register',
      name: 'register',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: register,
      meta: {
        title: '注册',
        keepAlive: true,
        isBack: false
      }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js